import React from "react";

import { MinusIcon, TickIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { THIRD_PARTIES } from "Constants/integrationThirdParties";

import * as S from "./Specificities.styles";

import type { Integration } from "@packages/client";

type GitProps = { integration: Integration };

const Git = ({ integration }: GitProps) => {
  const intl = useIntl();

  const config = THIRD_PARTIES.find(elt => elt.type === integration.type);

  const repository = (() => {
    const path: string[] = [];
    let baseUrl = integration.base_url
      ? integration.base_url
      : config?.base_url;

    if (baseUrl?.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }

    if (baseUrl) path.push(baseUrl);
    if (integration.project) path.push(integration.project);
    if (integration.repository) path.push(integration.repository);
    return path.join("/");
  })();

  return (
    <S.Wrapper>
      <S.RepoInfo>
        {integration.id && (
          <div>
            <span>{integration.id}</span>
            <label>
              {intl.formatMessage({
                id: "integration.git.id",
                defaultMessage: "ID"
              })}
            </label>
          </div>
        )}
        {repository && (
          <div>
            <a href={repository} target="_blank" rel="noopener noreferrer">
              {repository}
            </a>
            <label>
              {intl.formatMessage({
                id: "integration.git.repository",
                defaultMessage: "Repository"
              })}
            </label>
          </div>
        )}

        {integration.base_url && (
          <div>
            <a
              href={integration.base_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {integration.base_url}
            </a>
            <label>
              {intl.formatMessage({
                id: "integration.git.base_url",
                defaultMessage: "Enterprise base URL"
              })}
            </label>
          </div>
        )}
      </S.RepoInfo>
      <dl>
        <dt>
          {intl.formatMessage({
            id: "integration.git.settings",
            defaultMessage: "Project settings"
          })}
        </dt>

        {config?.options?.map(kind => {
          const hasKind = !!integration[kind];
          const Ico = hasKind ? TickIcon : MinusIcon;
          return (
            <S.SettingsLine key={`l-${kind}`} isActivate={hasKind}>
              <Ico />
              {intl.formatMessage(
                {
                  id: `integration.git.${kind}`,
                  defaultMessage: `Setting ${kind}`
                },
                {
                  name: (
                    <span>
                      {intl.formatMessage({
                        id: `integration.type.${integration.type}`
                      })}
                    </span>
                  )
                }
              )}
            </S.SettingsLine>
          );
        })}
      </dl>
    </S.Wrapper>
  );
};

export default Git;
